{
  "advanced-link-form": {
    "raw": {
      "tab": "Text"
    },
    "rich": {
      "tab": "Formatted Text",
      "description": "Copy this link in Libre Office, Word, Google Document, etc."
    },
    "markdown": {
      "tab": "Markdown",
      "description": "Copy this link for online platforms supporting Markdown."
    },
    "html": {
      "tab": "HTML"
    }
  },
  "app-header": {
    "navbar": {
      "investigations": "Investigations",
      "leak": "Leak to us",
      "support": "Support us",
      "follow": "Follow ICIJ"
    }
  },
  "generic-header": {
    "navbar": {
      "investigations": "Investigations",
      "leak": "Leak to us",
      "support": "Support us",
      "follow": "Follow ICIJ"
    }
  },
  "imddb-header": {
    "navbar": {
      "leak": "Leak to us",
      "support": "Support us",
      "follow": "Follow ICIJ"
    }
  },
  "embeddable-footer": {
    "share": "Share"
  },
  "embed-form": {
    "heading": "Embed on your website",
    "introduction": "Copy the code below to embed this on your website.",
    "responsive-optin": "Responsive iFrame",
    "copy": "Copy"
  },
  "follow-us-popover": {
    "heading": "Follow us"
  },
  "app-footer": {
    "investigations": "Investigations",
    "follow-us": "Follow us",
    "all-rights": "All rights reserved",
    "version": "Version {version}"
  },
  "generic-footer": {
    "investigations": "Investigations",
    "follow-us": "Follow us",
    "all-rights": "All rights reserved",
    "version": "Version {version}"
  },
  "donate-form": {
    "support": "Support us",
    "introduction": "ICIJ’s investigations are supported by readers like you. Help keep our databases free and open to the public by joining our <strong><a target=\"_blank\" href=\"https://icij.org/donate\">ICIJ Insiders</a></strong> community.",
    "join-heading": "Won't you join us today?",
    "label": "I would like to donate",
    "frequency": {
      "monthly": "Monthly",
      "yearly": "Yearly",
      "onetime": "One time"
    },
    "result": {
      "sentence": "With this donation, you are <strong>changing the %{target}</strong>.",
      "conversation": "conversation",
      "rules": "rules",
      "world": "world"
    },
    "suggesteddonation": {
      "conversation": {
        "monthly": 10,
        "yearly": 25,
        "onetime": 50
      },
      "rules": {
        "monthly": 25,
        "yearly": 180,
        "onetime": 200
      },
      "world": {
        "monthly": 100,
        "yearly": 600,
        "onetime": 600
      }
    },
    "submit": "Donate now",
    "benefits": {
      "heading": "ICIJ Insiders benefits",
      "introduction": "Your monthly or annual donation will give you the following benefits.",
      "more": "More about donations",
      "list": [
        "Invitation to exclusive chat with ICIJ staff about our latest major project after publication",
        "Opportunity to submit your questions to ICIJ staff. Several questions will be answered in our quarterly ICIJ Insider newsletter",
        "Sneak previews behind the scenes of ICIJ’s work (monthly)",
        "ICIJ Insider Newsletter (quarterly)",
        "ICIJ’s Weekly Update"
      ],
      "impacts": {
        "conversation": {
          "level": "conversation",
          "heading": "Change the conversation",
          "highlight": "$1-$179/Year <span class='monthly'>or $1-$14/Month</span>"
        },
        "rules": {
          "level": "rules",
          "heading": "Change the rules",
          "highlight": "$180-$599/Year <span class='monthly'>or $15-$49/Month</span>"
        },
        "world": {
          "level": "world",
          "heading": "Change the world",
          "highlight": "$600+/Year <span class='monthly'>or $50+/Month</span>"
        }
      }
    }
  },
  "sign-up-form": {
    "label": "Stories in your inbox",
    "placeholder": "Enter your email",
    "submit": "Sign up"
  },
  "haptic-copy": {
    "label": "Copy",
    "tooltip": {
      "succeed": "Copied!",
      "failed": "Unable to copy the text"
    }
  },
  "custom-pagination": {
    "placeholder": "Jump to page",
    "compact-placeholder": "Jump to...",
    "total-pages": "No pages | 1 page | {count} pages total",
    "invalid-number-error": "Invalid page number"
  },
  "tiny-pagination": {
    "page": "Page",
    "aria": "Jump to page",
    "ariaRow": "Jump to row",
    "total": "of {numberOfPages}",
    "rowRange": "to {lastRangeRow} of 0 rows | to {lastRangeRow} of 1 row | to {lastRangeRow} of {totalRows} rows",
    "rowRangeFewer": "of 0 rows | of 1 row | to {totalRows} rows",
    "uniqueRowRange": "of 0 rows | of 1 row | of {totalRows} rows",
    "compactRowRange": "to {lastRangeRow}",
    "previous": "Previous page",
    "next": "Next page",
    "first": "First page",
    "last": "Last page"
  }
}
